// TeamWorkAreaSection — "Works in" (ADR-083 §6), the page's and the peek's read
// face: the places by kind as chips wearing their kind's glyph (the scope
// summary's grammar — one chip system for "places" wherever they are read), the
// whole project one chip, the places outside the viewer's reach a COUNT (never
// named — ADR-066 §9), nothing yet = "Works nowhere yet". A different axis from
// scope: where the team's work can be, never what a member sees.

import { useTranslation } from 'react-i18next';
import type { TeamWorkArea } from '@ems-app/schemas/teams/responses';
import { PlaceTag } from '../../components/patterns/PlaceTag.js';
import { icons } from '../../components/ui/icons.js';

export function TeamWorkAreaSection({ area, className = '' }: { area: TeamWorkArea; className?: string }) {
  const { t } = useTranslation('teams');
  const outside = area.outside.sites + area.outside.warehouses + area.outside.vehicle_pools;
  const named = area.zones.length + area.clusters.length + area.sites.length + area.warehouses.length + area.vehicle_pools.length;
  if (area.whole_project) {
    return (
      <div className={`flex flex-wrap items-center gap-1.5 ${className}`}>
        <PlaceTag glyph={icons.building}>{t('detail.wholeProject')}</PlaceTag>
      </div>
    );
  }
  if (named === 0 && outside === 0) return <p className={`text-sm text-[var(--color-text-secondary)] ${className}`}>{t('detail.worksInEmpty')}</p>;
  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`}>
      {area.zones.map((z) => (
        <PlaceTag key={`z${z.id}`} glyph={icons.zone}>{z.name}</PlaceTag>
      ))}
      {area.clusters.map((c) => (
        <PlaceTag key={`c${c.id}`} glyph={icons.cluster}>{c.name}</PlaceTag>
      ))}
      {area.sites.map((s) => (
        <PlaceTag key={s.id} glyph={icons.site}>{s.name}</PlaceTag>
      ))}
      {area.warehouses.map((w) => (
        <PlaceTag key={w.id} glyph={icons.warehouse}>{w.name}</PlaceTag>
      ))}
      {area.vehicle_pools.map((p) => (
        <PlaceTag key={p.id} glyph={icons.vehicle}>{p.name}</PlaceTag>
      ))}
      {outside > 0 && <span className="text-xs text-[var(--color-text-secondary)]">{t('detail.outsideKept', { count: outside })}</span>}
    </div>
  );
}
